import classNames from "classnames";
import { DComponent } from "../../../../components/DComponent";

export default class ProductSummaryPopup extends DComponent {
  constructor({
    parent,
    id,
    titleSection,
    onBack,
    isBack = false,
  } = {}) {
    super(arguments[0], parent, id, {
      class: classNames("ProductSummaryPopup")
    }, true);
    this.titleSection = titleSection;
    this.onBack = onBack;
    this.isBack = isBack;
    this.render();
  }

  loadStyle() {
    const style = require("!!css-loader!resolve-url-loader!sass-loader!./style.scss").toString();
    this.appendStyle(style, "ProductSummaryPopup");
  }

  loadHtml() {
    return require("html-loader!./index.html");
  }

  after() {
    if (this.isBack) {
      $(".back", this.element).on("click", () => {
        typeof this.onBack === "function" && this.onBack();
        this.hide();
      })
    } else {
      $(".back", this.element).addClass("hide");
    }

    this.element.on("hide.bs.modal", () => {
      $("html, body").css("overflow", "auto");
    })
  }

  loadData(data) {
    $(".description-content", this.element).html(data);
    if (this.titleSection) {
      $(".description-content .title", this.element).text($.i18n(this.titleSection));
      $(".description-content .title", this.element).attr("data-i18n", this.titleSection);
    }
  }

  show() {
    $("html, body").css("overflow", "hidden");
    $(this.element).modal("show");
  }

  hide() {
    $(this.element).modal("hide");
  }

  /** @param {ProductSummaryPopup} _params */
  updateAttributes(_params = {}) {
    Object.keys(_params).forEach(key => {
      this[key] = _params[key];
    });
  }
}